<template lang="pug">
  .thumb-container
    .thumb(:style="thumbStyle")
</template>

<script>
  export default {
    name: "Thumbnail",
    data() {
      return {

      }
    },
    props: {
      image: {
        type: String,
        default: ''
      }
    },
    computed: {
      thumbStyle: function() {
        return {
          backgroundImage: `url(${this.image})`,
        }
      }
    }
  }
</script>

<style lang="sass">
  .thumb-container
    min-width: 4em
    .thumb
      width: 100%
      height: 0
      padding-bottom: calc(100% - 8px)
      border-radius: 10em
      box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.2)
      border: 4px solid white
      background-size: cover
      background-position: center
      box-sizing: border-box
</style>


// WEBPACK FOOTER //
// thumbnail.vue?7b39f1ef